import React from 'react';

/**
 * TableAction Component
 * A standardized, premium action button for use within DataTables.
 * Part of the "Tangrid" design system.
 */
const TableAction = ({
    icon: Icon,
    onClick,
    title,
    color = 'blue',
    className = '',
    disabled = false
}) => {
    // Standard color mappings - semantic colors for actions
    const colorVariants = {
        blue: 'hover:text-highlight-600 hover:bg-highlight-50 dark:hover:bg-highlight-500/10',
        emerald: 'hover:text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-500/10',
        indigo: 'hover:text-highlight-600 hover:bg-highlight-50 dark:hover:bg-highlight-500/10',
        amber: 'hover:text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-500/10',
        rose: 'hover:text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-500/10',
        slate: 'hover:text-gray-600 hover:bg-gray-50 dark:hover:bg-gray-500/10',
    };

    const variantClass = colorVariants[color] || colorVariants.blue;

    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                if (!disabled && onClick) onClick(e);
            }}
            disabled={disabled}
            className={`
                p-1.5 rounded transition-all shadow-sm 
                bg-white dark:bg-gray-800 
                border border-gray-200 dark:border-gray-700
                text-gray-500 dark:text-gray-400
                active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed
                ${variantClass} 
                ${className}
            `.trim()}
            title={title}
        >
            {Icon && <Icon className="w-4 h-4" />}
        </button>
    );
};

/**
 * TableActionGroup Component
 * A container for grouping multiple TableAction components.
 */
export const TableActionGroup = ({ children, className = '', justify = 'center' }) => {
    const justifyClasses = {
        center: 'justify-center',
        end: 'justify-end',
        start: 'justify-start'
    };

    return (
        <div className={`flex items-center gap-1.5 px-2 ${justifyClasses[justify]} ${className}`}>
            {children}
        </div>
    );
};

/**
 * TableActionDivider Component
 */
export const TableActionDivider = () => (
    <div className="w-px h-4 bg-gray-200 dark:bg-gray-700 mx-0.5" />
);

export default TableAction;
